import axios, { AxiosResponse } from 'axios';
import routes from '../../utils/routes';

export const createEmailVerification = (): Promise<AxiosResponse> => {
  return axios.post(routes.API_TFA_GENERATE_EMAIL_TOKEN);
};

export const createPhoneVerificationViaCall = (): Promise<AxiosResponse> => {
  return axios.post(routes.API_TFA_GENERATE_CALL_TOKEN);
};

export const createPhoneVerificationViaSms = (): Promise<AxiosResponse> => {
  return axios.post(routes.API_TFA_GENERATE_SMS_TOKEN);
};
// eslint-disable-next-line max-len
export const createPhoneVerificationViaSmsAndUpdatePhone = (phone: string): Promise<AxiosResponse> => {
  return axios.post(routes.API_TFA_GENERATE_SMS_TOKEN_AND_UPDATE_PHONE, { phone });
};

export const verifyPhoneViaToken = (token): Promise<AxiosResponse> => {
  return axios.post(routes.API_TFA_VERIFY_TOKEN, { token });
};

export const resendTfaCode = (method: string): Promise<AxiosResponse> => {
  return axios.post(routes.TFA_RESEND_CODE, { method });
};

export type SignupRole = 'user' | 'seller';

export type UserCreationRequest = {
  first_name: string,
  last_name: string,
  email: string,
  password: string,
  role: SignupRole,
};
